import React from 'react';
import { camelCase } from 'lodash';
import {
  Badge, Col, Row, Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { TableStatusProps } from './types';
import { statusColor } from '../../../_helpers';

const TableStatus = ({ text }: TableStatusProps) => {
  const { t } = useTranslation();
  const color = {
    disabled: `${statusColor.maroon}`,
    approved: `${statusColor.green}`,
    incomplete: `${statusColor.gold}`,
    rejected: `${statusColor.red}`,
    loaded: `${statusColor.lightBlue}`,
    notLoaded: `${statusColor.black}`,
    expired: `${statusColor.darkGrey}`,
    pending: `${statusColor.orange}`,
    digitalReview: `${statusColor.darkBlue}`,
    digitalReviewApproved: `${statusColor.darkBlue}`,
    digitalReviewWithObservations: `${statusColor.darkOrange}`,
    deactivated: `${statusColor.indianRed}`,
    deleted: `${statusColor.indianRed}`,
    enabled: `${statusColor.green}`,
    blocked: `${statusColor.red}`,
    authorized: `${statusColor.green}`,
    notAuthorized: `${statusColor.red}`,
    notEnabled: `${statusColor.grey}`,
    notReviewed: `${statusColor.lightBlue}`,
    accepted: `${statusColor.green}`,
    iddle: `${statusColor.orange}`,
    accessDenied: `${statusColor.red}`,
    unannotated: `${statusColor.green}`,
    annotated: `${statusColor.orange}`,
  };

  const camelCaseStatus = camelCase(text);
  const { Text } = Typography;
  const itemStatus = camelCaseStatus;
  const normalizedStatus = (status: string) => status;
  const localeStatus = t(`utils.tableStatus.${normalizedStatus(itemStatus)}`);

  return (
    <Row className="flex flex-row  items-center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Badge
          color={text && color[itemStatus as keyof typeof color]}
          text={(<Text className="text-gray-600 text-xs xs:text-xs sm:text-xs md:text-xs lg:text-xs xl:text-xs 2xl:text-xs">{localeStatus}</Text>)}
          className="whitespace-nowrap"
        />
      </Col>
    </Row>
  );
};

export default TableStatus;
